
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agents/custom-agents",
      function () {
        return require("private-next-pages/agents/custom-agents.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agents/custom-agents"])
      });
    }
  